export const Shell = ({ ...props }) => {
  return <div className="flex h-dvh flex-col print:h-auto" {...props} />;
};

Shell.displayName = "Shell";
